var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"lg","id":"modal_vue","lazy":"","hide-footer":""}},[_c('div',{ref:"inn",staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.modal_testo)}})])}
var staticRenderFns = []

export { render, staticRenderFns }